// extracted by mini-css-extract-plugin
export var chatHtmlText = "_td-2";
export var chatLink = "_td-0";
export var chatText = "_td-1";